import { ThemeUIStyleObject } from 'theme-ui';
// eslint-disable-next-line
// @ts-ignore
import codeTheme from '@theme-ui/prism/presets/dracula.json';
import { CarrotTheme } from '..';

const baseStyles = {
    code: {
        ...codeTheme,
    },
    inlineCode: {
        fontFamily: 'monospace',
        backgroundColor: (theme: CarrotTheme) => theme.colors.black10,
    },
    pre: {
        padding: (theme: CarrotTheme) => theme.space.small,
        border: (theme: CarrotTheme) => `1px solid ${theme.colors.black10}`,
        marginBottom: (theme: CarrotTheme) => theme.space.small,
        borderRadius: '8px',
        fontFamily: 'monospace',
        overflow: 'auto',
        '.comment': {
            color: (theme: CarrotTheme) => theme.colors.black40,
        },
    },
};

const pre: Record<string, ThemeUIStyleObject> = {
    ...baseStyles,
};
export default pre;
